export default __webpack_public_path__ + "static/media/whatsapp_chats_blank.1d697a9e.jpg";